<template>
  <div>
    <v-dialog v-model="dialogOpen"
      v-if="dialogOpen"
      content-class="my-custom-dialog"
      transition="dialog-top-transition"
      scrollable
      max-width="60%"
      @keydown.esc="close"
      style="height: 50px"
      eager>
      <confirm ref="confirmStorno"
        @selection="cancelReceipt" />
      <v-card tile
        color="white">
        <v-card-title style="
            height: 80px;
            padding-top: 0px;
            position: sticky;
            border-bottom: 1px solid lightgrey;
          ">
          <v-col cols="5">
            <v-row>
              <h3 class="text--secondary">
                {{ $t("$vuetify.cashRegister.receiptsOverview") }}
              </h3>
            </v-row>
            <v-row>
              <h5>
                Od:
                {{
                  new Date(last_balance_timestamp * 1000).toLocaleString(
                    "hr-HR"
                  )
                }}
              </h5>
            </v-row>
          </v-col>
          <v-col v-if="!unfiskReceipts || unfiskReceipts.length === 0"
            cols="5">
            <v-text-field class="ma-0"
              style="position: relative; top: 0.8rem"
              outlined
              dense
              clearable
              data-layout="numericAduro"
              v-model="searchNumber"
              :label="$t('$vuetify.cashRegister.searchByReceiptNumber')"
              @click:prepend="doSearch"
              @click:clear="clearSearch"
              @click:append="doSearch"
              @focus="showKbd"
              @click="showKbd"
              @keydown.enter="doSearch"
              @keypress.enter.prevent="doSearch"></v-text-field>
          </v-col>
          <v-col v-if="!unfiskReceipts || unfiskReceipts.length === 0"
            cols="2"><v-btn @click="doSearch"><v-icon>mdi-magnify</v-icon></v-btn></v-col>
        </v-card-title>
        <v-card-text ref="scrollContainer" style="padding: 0; margin: 0; overflow-x: hidden; height: 600px; position: relative;">
          <v-row>
            <v-col cols="12"
              style="min-width: 100%">
              <div v-if="loading" class="loading-overlay-receipts">
                <v-progress-circular
                  indeterminate
                  size="64"
                  class="loading-spinner">
                </v-progress-circular>
              </div>
              <v-expansion-panels focusable>
                <v-expansion-panel v-for="(receipt, i) in receipts"
                  :key="i"
                  hover
                  tabindex="0"
                  class="receipt-card"
                  style="border-radius: 0">
                  <v-expansion-panel-header height="200"
                    :class="[
                      receipt.payment_method !== 'TRANSAKCIJSKI RAČUN' &&
                        receipt.type.flag !== 'P' &&
                        receipt.fiscalize === true &&
                        receipt.zki !== '' &&
                        receipt.jir === '' &&
                        issueBefore(receipt.issue_date_time) > now
                        ? 'status-failed-exp'
                        : 'status-ok-exp',
                      receipt.payment_method !== 'TRANSAKCIJSKI RAČUN' &&
                        receipt.type.flag !== 'P' &&
                        receipt.fiscalize === true &&
                        receipt.zki !== '' &&
                        receipt.jir === '' &&
                        issueBefore(receipt.issue_date_time) < now
                        ? 'status-failed-expired'
                        : 'status-ok-exp',
                      receipt.payment_method === 'TRANSAKCIJSKI RAČUN' &&
                        receipt.type.flag !== 'P' &&
                        parseInt(receipt.payment_due) > now &&
                        receipt.payment !== undefined &&
                        receipt.payment.current_status !== 'PAID'
                        ? 'status-warn-exp'
                        : '',
                      receipt.payment_method === 'TRANSAKCIJSKI RAČUN' &&
                        receipt.type.flag !== 'P' &&
                        parseInt(receipt.payment_due) < now &&
                        receipt.payment !== undefined &&
                        receipt.payment.current_status !== 'PAID'
                        ? 'status-warn-after-exp'
                        : '',
                      receipt.payment_method === 'TRANSAKCIJSKI RAČUN' &&
                        receipt.type.flag !== 'P' &&
                        receipt.payment !== undefined &&
                        receipt.payment.current_status === 'PAID'
                        ? 'status-ok-exp'
                        : '',
                      receipt.payment_method === 'TRANSAKCIJSKI RAČUN' &&
                        receipt.type.flag === 'P'
                        ? 'status-ok-exp'
                        : '',
                      receipt.payment !== undefined &&
                        receipt.payment.current_status === 'REVERSED'
                        ? 'status-reversed'
                        : '',
                      receipt.type.flag === 'STORNO' ? 'status-storno' : '',
                    ]"
                    hide-actions>
                    <v-row>
                      <v-col cols="3">
                        <div class="caption grey--text text-center">
                          {{
                            reciptOffer === "receipts"
                              ? $t("$vuetify.receipts.receiptNumber")
                              : $t("$vuetify.receipts.offerNumber")
                          }}
                        </div>
                        <div class="text-center"
                          v-html="receipt.receiptNumber"></div>
                      </v-col>
                      <v-col cols="3">
                        <div class="caption grey--text text-right">
                          {{
                            reciptOffer === "receipts"
                              ? $t("$vuetify.receipts.receiptPrice")
                              : $t("$vuetify.receipts.offerPrice")
                          }}
                        </div>
                        <div class="text-right">
                          {{ receipt.total | money(100, receipt.currency) }}
                        </div>
                      </v-col>
                      <v-col cols="4">
                        <div class="caption grey--text text-center">
                          {{ $t("$vuetify.receipts.receiptIssueDate") }}
                        </div>
                        <div class="text-center">
                          {{ receipt.issue_date_time | local }}
                        </div>
                      </v-col>
                      <v-col cols="2"
                        class="d-flex justify-end"
                        style="margin-top: 0px">
                        <v-btn min-height="50"
                          min-width="50"
                          plain
                          rounded
                          @click.native.stop
                          @keypress.enter.prevent="openMenu(receipt)"
                          @click="openMenu(receipt)">
                          <v-icon>mdi-dots-vertical</v-icon>
                        </v-btn>

                        <!-- <v-menu offset-y>
                          <template v-slot:activator="{ on, attrs }">
                            <v-btn
                              icon
                              v-bind="attrs"
                              v-on="on"
                              @keypress.enter.stop=""
                            >
                              <v-icon>mdi-dots-vertical</v-icon>
                            </v-btn>
                          </template>
<v-list dense>
  <v-list-item v-for="(item, index) in receipt.receiptOptions" :key="index" style="cursor: pointer"
    @click="`${item.action(receipt)}`" @keypress.enter.prevent="
                                `${item.action(receipt)}`
                              " :disabled="
                                receipt.payment &&
                                receipt.payment.current_status === 'PROCESSING'
                              ">
    <v-list-item-title>{{
                                item.title
                              }}</v-list-item-title>
  </v-list-item>
</v-list>
</v-menu> -->
                      </v-col>
                    </v-row>
                  </v-expansion-panel-header>
                  <v-expansion-panel-content>
                    <v-row>
                      <v-col cols="12"
                        sm="5">
                        <div class="d-flex justify-space-between text-center text-subtitle-2">
                          Operater: {{ receipt.seller_id }}
                        </div>
                        <div class="d-flex justify-space-between text-center text-subtitle-2">
                          Način plaćanja: {{ receipt.payment_method }}
                        </div>
                      </v-col>
                    </v-row>
                    <v-list>
                      <v-row>
                        <v-col>
                          <div class="text-center text-subtitle-2 one-liner-text font-weight-bold">
                            R. br.
                          </div>
                        </v-col>
                        <v-col>
                          <div class="text-center text-center text-subtitle-2 one-liner-text font-weight-bold">
                            Naziv
                          </div>
                        </v-col>
                        <v-col>
                          <div class="text-center text-center text-subtitle-2 one-liner-text font-weight-bold">
                            Količina
                          </div>
                        </v-col>
                        <v-col>
                          <div class="text-center text-center text-subtitle-2 one-liner-text font-weight-bold">
                            Jedinična cijena
                          </div>
                        </v-col>
                        <v-col>
                          <div class="text-center text-center text-subtitle-2 one-liner-text font-weight-bold">
                            Cijena
                          </div>
                        </v-col>
                      </v-row>
                      <v-list-item v-for="(item, index) in receipt.items"
                        :key="index"
                        class="pa-0">
                        <v-row class="pa-0">
                          <v-col>
                            <div class="text-center text-subtitle-2">
                              {{ index + 1 }}
                            </div>
                          </v-col>
                          <v-col>
                            <div class="text-center text-subtitle-2">
                              {{ item.name }}
                            </div>
                          </v-col>
                          <v-col>
                            <div class="text-center text-subtitle-2">
                              {{ item.amt / multiplier }}
                            </div>
                          </v-col>
                          <v-col>
                            <div class="text-center text-subtitle-2">
                              {{
                                item.single_item_price
                                | money(100, receipt.currency)
                              }}
                            </div>
                          </v-col>
                          <v-col>
                            <div class="text-center text-subtitle-2">
                              {{ item.price | money(100, receipt.currency) }}
                            </div>
                          </v-col>
                        </v-row>
                      </v-list-item>
                    </v-list>
                  </v-expansion-panel-content>
                </v-expansion-panel>
              </v-expansion-panels>

              <!-- Load More Button -->
              <v-row v-if="hasMoreReceipts" class="justify-center mt-4 mb-4">
                <v-btn
                  class="page-nav-btn-header"
                  @click="loadMore"
                  :loading="loading"
                  :disabled="loading"
                  elevation="2">
                  Učitaj više
                  <v-icon small class="ml-2">mdi-chevron-down</v-icon>
                </v-btn>
              </v-row>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
      <payment-change ref="paymentChanges"
        @receiptEdit="onReceiptEdit"
        @reprintReceipt="onReceiptReprint"></payment-change>
    </v-dialog>
    <v-container class="kbd"
      v-if="!$vuetify.breakpoint.smAndDown"
      ref="keyboard"
      v-show="oskVisible"
      :style="{ 'max-width': width }">
      <div class="kbd-header"></div>
      <vue-touch-keyboard :options="oskOptions"
        :layout="layout"
        :cancel="hideKbd"
        :accept="accept"
        :input="input" />
    </v-container>
    <change-receipt-type-dialog ref="chengeReceiptTypeDialog"></change-receipt-type-dialog>
    <add-tip ref="addTip"
      @receiptEdit="onReceiptEdit"
      @reprintReceipt="onReceiptReprint"></add-tip>
    <receipt-menu ref="receiptMenu"
      @menuClicked="onMenuClicked"></receipt-menu>
  </div>
</template>
<script>
import { df, auth, functions } from '@/plugins/firebase'
import { clone, toISOLocal } from '@/plugins/utils'
import applicationSettings from '@/mixins/applicationSettings'
import { reprint } from '@/libs/bixolon/reprint'
import { print58 } from '@/libs/bixolon/print58'
import state from '@/state'
import { v4 as uuidv4 } from 'uuid'
import Confirm from '@/components/Confirm.vue'
import PaymentChange from '@/modules/company/components/PaymentChange'
import onScreenKeyboard from '@/mixins/onScreenKeyboard'
import ChangeReceiptTypeDialog from '@/modules/cash-register/components/dialogs/ChangeReceiptTypeDialog.vue'
import AddTip from '@/modules/company/components/AddTip'
import ReceiptMenu from '@/modules/cash-register/components/dialogs/ReceiptMenu.vue'
import LogData from '@/model/LogData'
import log from '@/mixins/log'
import { callAssociates } from '@/api/associates'

export default {
  components: {
    Confirm,
    PaymentChange,
    ChangeReceiptTypeDialog,
    AddTip,
    ReceiptMenu
  },
  mixins: [applicationSettings, onScreenKeyboard, log],
  inject: [
    'showMsgBox',
    'showLoader',
    'hideLoader',
    'openPdfPrint',
    'closePdfPrint'
  ],
  data () {
    return {
      dialogOpen: true,
      loading: false,
      receipts: [],
      unfiskReceipts: [],
      location: {},
      statusFilter: {},
      receiptNumberFilter: '',
      receiptNumberParsed: null,
      lastDocSnapshot: null,
      reciptOffer: {},
      associates: [],
      multiplier: 0,
      filtersExpanded: false,
      searchNumber: '',
      register: null,
      document: null,
      last_balance_timestamp: new Date(new Date().setHours(0, 0, 0, 0)).valueOf() / 1000,
      firstNewReceiptId: null
    }
  },
  watch: {
    dialogOpen (val) {
      !val && this.$emit('closeReceiptsDialog')
    },
    searchNumber (newVal, oldVal) {
      // If search field becomes empty (user deleted all characters)
      if (oldVal && oldVal.length > 0 && (!newVal || newVal.length === 0)) {
        this.clearSearch()
      }
    }
  },
  computed: {
    reciptOfferChoices () {
      return [
        { name: this.$tc('$vuetify.receipt', 2), value: 'receipts' },
        { name: this.$tc('$vuetify.offer', 2), value: 'offers' },
        { name: 'Virman', value: 'virmans' }
      ]
    },
    now () {
      return parseInt((`${new Date().getTime()}` / 1000).toFixed(0))
    },
    hasMoreReceipts () {
      return this.lastDocSnapshot !== null
    }
  },
  methods: {
    onMenuClicked (item, receipt) {
      var func = item.action
      func(receipt)
    },
    openMenu (receipt) {
      this.$refs.receiptMenu.open(receipt, 0)
    },
    addTip (receipt) {
      this.$refs.addTip.open(receipt)
    },
    close () {
      this.$emit('closeReceiptsDialog')
    },
    applyFilter () {
      this.lastDocSnapshot = null
      this.receipts = []
      this.unfiskReceipts = []
      this.loadReceipts()
    },
    navigateToFlow () {
      this.$router.push({
        name: 'Home',
        params: {
        }
      })
    },
    async loadReceipts () {
      if (this.loading) return
      this.loading = true

      try {
        const where = state.getPointOfSale().location_id
        const cashReg = state.getCashRegister()

        let receiptNumberParsed
        if (this.receiptNumberFilter !== '') {
          receiptNumberParsed = this.parseReceiptNumber(this.receiptNumberFilter)
        }

        let query = df
          .collection(
            `${this.reciptOffer}/${state.getCurrentCompany().id}/${this.reciptOffer}`
          )
          .orderBy('issue_date_time', 'desc')
          .limit(10)

        if (this.lastDocSnapshot) {
          query = query.startAfter(this.lastDocSnapshot)
        }

        switch (cashReg.type) {
          case 'MP':
            query = query.where('payment_method', 'in', ['NOVČANICE', 'KARTICA', 'OSTALO'])
            break
          case 'VP':
            query = query.where('payment_method', '==', 'TRANSAKCIJSKI RAČUN')
        }

        if (where) {
          query = query.where('designation.location_id', '==', where)
        }

        if (this.searchNumber && this.searchNumber.length > 0) {
          query = query.where('designation.number', '==', Number(this.searchNumber))
        } else {
          query = query.where('issue_date_time', '>', this.last_balance_timestamp)
        }

        if (receiptNumberParsed) {
          query = query
            .where('designation.number', '==', receiptNumberParsed.number)
            .where('designation.location_id', '==', receiptNumberParsed.location_id)
            .where('designation.register_number', '==', receiptNumberParsed.register_number)
        }

        const snapshot = await query.get()

        // Clear receipts before adding new ones (only on initial load, not on "load more")
        if (!this.lastDocSnapshot) {
          this.receipts = []
          this.unfiskReceipts = []
        }

        if (!snapshot.empty) {
          // Remember the first document ID from the new batch
          if (snapshot.docs.length > 0 && this.lastDocSnapshot) {
            this.firstNewReceiptId = snapshot.docs[0].id
          }

          snapshot.docs.forEach(doc => {
            const change = { doc, type: 'added' }
            this.modifyItems(change)
          })

          if (snapshot.docs.length > 0) {
            this.lastDocSnapshot = snapshot.docs[snapshot.docs.length - 1]
          } else {
            this.lastDocSnapshot = null
          }
        } else {
          this.lastDocSnapshot = null
        }
      } catch (error) {
        console.error('Error fetching documents: ', error)
      } finally {
        this.loading = false
      }
    },

    async loadMore () {
      if (!this.hasMoreReceipts || this.loading) return

      // Remember the ID of the last receipt from current list (before loading new ones)
      const lastOldReceiptId = this.receipts.length > 0 ? this.receipts[this.receipts.length - 1].id : null

      await this.loadReceipts()

      // After loading, scroll so the last old receipt appears at the top of the visible area
      this.$nextTick(() => {
        setTimeout(() => {
          if (!lastOldReceiptId) return

          const cardTextElement = this.$refs.scrollContainer
          if (!cardTextElement) return

          // Find the index of the last old receipt by ID
          const lastOldReceiptIndex = this.receipts.findIndex(r => r.id === lastOldReceiptId)
          if (lastOldReceiptIndex === -1) return

          // Get all expansion panels
          const receiptPanels = cardTextElement.querySelectorAll('.v-expansion-panel')

          if (receiptPanels[lastOldReceiptIndex]) {
            const targetElement = receiptPanels[lastOldReceiptIndex]
            const targetScrollTop = targetElement.offsetTop

            // Smooth scroll animation
            this.smoothScrollTo(cardTextElement, targetScrollTop, 400)
          }
        }, 100)
      })
    },
    smoothScrollTo (element, target, duration) {
      const start = element.scrollTop
      const change = target - start
      const startTime = performance.now()

      const animateScroll = (currentTime) => {
        const elapsed = currentTime - startTime
        const progress = Math.min(elapsed / duration, 1)

        // Easing function (ease-in-out)
        const easeInOutQuad = progress < 0.5
          ? 2 * progress * progress
          : 1 - Math.pow(-2 * progress + 2, 2) / 2

        element.scrollTop = start + change * easeInOutQuad

        if (progress < 1) {
          requestAnimationFrame(animateScroll)
        }
      }

      requestAnimationFrame(animateScroll)
    },
    modifyItems (change) {
      if (change.type === 'added') {
        if (change.doc.data()) {
          const _document = clone(change.doc.data())
          const issueDate = new Date(_document.issue_date_time * 1000)
          const nowDate = new Date(Date.now())

          switch (_document.type.flag) {
            case 'R':
            case 'R1':
            case 'R2':
            case 'BO':
              _document.receiptOptions = [
                { title: 'Preuzmi račun', action: this.printReceiptNew },
                { title: 'Storniraj račun', action: this.stornoReceipt },
                { title: 'Ponovi ispis', action: this.reprintReceipt },
                { title: 'Konz. jela i pića', action: this.reprintReceiptKonzumacijaJelaIpica },
                { title: this.$t('$vuetify.formDetails.changeReceiptType'), action: this.changeReceiptType }
              ]

              if (_document.payment_method !== 'TRANSAKCIJSKI RAČUN' && _document.jir !== '' && this.issueBefore(_document.issue_date_time) > this.now) {
                _document.receiptOptions.push({
                  title: 'Dodaj napojnicu',
                  action: this.addTip
                })
              }

              if (_document.payment_method !== 'TRANSAKCIJSKI RAČUN' && _document.jir === '') {
                _document.receiptOptions = _document.receiptOptions.filter((options) =>
                  options.title !== 'Storniraj račun')
              }

              if (
                _document.payment?.current_status !== 'PAID' &&
                _document.payment_method === 'TRANSAKCIJSKI RAČUN'
              ) {
                _document.receiptOptions.push({
                  title: 'Plati račun',
                  action: this.payReceipt
                })
                _document.receiptOptions.push({
                  title: 'Opomeni korisnika',
                  action: this.sendWarningToClient
                })
              }

              if (
                _document.payment?.current_status !== 'UNPAID' &&
                _document.payment_method === 'TRANSAKCIJSKI RAČUN'
              ) {
                _document.receiptOptions.push({
                  title: 'Prebaci status u neplaćeno',
                  action: this.statusToUnpaid
                })
              }

              if (
                _document.payment?.current_status === 'PAID' &&
                _document.payment_method !== 'TRANSAKCIJSKI RAČUN' &&
                _document.fiscalize === true && _document.jir !== '' &&
                issueDate.getFullYear() === nowDate.getFullYear() &&
                issueDate.getMonth() === nowDate.getMonth() &&
                issueDate.getDate() === nowDate.getDate()

              ) {
                _document.receiptOptions.push({
                  title: 'Promijeni način plaćanja',
                  action: this.changePayment
                })
              }

              if (
                _document.payment?.current_status === 'REVERSED') {
                _document.receiptOptions = _document.receiptOptions.filter((options) =>
                  options.title !== 'Storniraj račun')
              }
              break
            case 'STORNO':
              _document.receiptOptions = [
                { title: 'Preuzmi račun', action: this.printReceiptNew }]
              break
            case 'P':
              _document.receiptOptions = [
                { title: 'Preuzmi ponudu', action: this.printReceiptNew },
                {
                  title: 'Izradi račun iz ponude',
                  action: this.generateReceipt
                }
              ]
              break
            case 'V':
              _document.receiptOptions = [
                { title: 'Preuzmi virman', action: '' },
                {
                  title: 'Izradi račun iz virmana',
                  action: this.generateReceipt
                }
              ]
          }

          let rcptSeparator = '-'
          if (_document.company_details.rcpt_separator !== undefined && _document.company_details.rcpt_separator !== '') {
            rcptSeparator = _document.company_details.rcpt_separator
          }

          if (_document.designation) {
            _document.receiptNumber = `${_document.designation.number}${rcptSeparator}${_document.designation.location_id}${rcptSeparator}${_document.designation.register_number}`
          }

          if (_document.company_details.rcpt_num_year === true) {
            var d = new Date(_document.issue_date_time * 1000)

            _document.receiptNumber += `  <b>${d.getFullYear()}</b> `
          }

          if (_document.issue_date_time) {
            _document.time = _document.issue_date_time.seconds
          }
          if (_document?.type?.flag !== 'BO' && _document?.type?.payer_name) {
            _document.customer = _document.type.payer_name
          } else {
            _document.customer = this.$t('$vuetify.receipts.retailCustomer')
          }

          _document.show = false

          this.receipts.push({
            ..._document,
            ...{ [`hover-${change.doc.data().id}`]: false }
          })
          // }

          this.receipts.sort((a, b) => b.issue_date_time - a.issue_date_time) // b - a for reverse sort
          this.$forceUpdate()
        }
      }
      if (change.type === 'modified') {
        // TODO: duplicated code, make 1 fun
        this.receipts = this.receipts.map(item => {
          let ret = item
          if (item.id === change.doc.data().id) {
            const _document = clone(change.doc.data())
            const issueDate = new Date(_document.issue_date_time * 1000)
            const nowDate = new Date(Date.now())

            switch (_document.type.flag) {
              case 'R':
              case 'R1':
              case 'R2':
              case 'BO':
                _document.receiptOptions = [
                  { title: 'Preuzmi račun', action: this.printReceiptNew },
                  { title: 'Storniraj račun', action: this.stornoReceipt },
                  { title: 'Ponovi ispis', action: this.reprintReceipt },
                  { title: 'Konz. jela i pića', action: this.reprintReceiptKonzumacijaJelaIpica },
                  { title: this.$t('$vuetify.formDetails.changeReceiptType'), action: this.changeReceiptType }
                ]

                if (_document.payment_method !== 'TRANSAKCIJSKI RAČUN' && _document.jir !== '' && this.issueBefore(_document.issue_date_time) > this.now) {
                  _document.receiptOptions.push({
                    title: 'Dodaj napojnicu',
                    action: this.addTip
                  })
                }

                if (
                  _document.payment?.current_status !== 'PAID' &&
                  _document.payment_method === 'TRANSAKCIJSKI RAČUN'
                ) {
                  _document.receiptOptions.push({
                    title: 'Plati račun',
                    action: this.payReceipt
                  })
                  _document.receiptOptions.push({
                    title: 'Opomeni korisnika',
                    action: this.sendWarningToClient
                  })
                }

                if (
                  _document.payment?.current_status !== 'UNPAID' &&
                  _document.payment_method === 'TRANSAKCIJSKI RAČUN'
                ) {
                  _document.receiptOptions.push({
                    title: 'Prebaci status u neplaćeno',
                    action: this.statusToUnpaid
                  })
                }

                if (
                  _document.payment?.current_status === 'PAID' &&
                  _document.payment_method !== 'TRANSAKCIJSKI RAČUN' &&
                  _document.fiscalize === true && _document.jir !== '' &&
                  issueDate.getFullYear() === nowDate.getFullYear() &&
                  issueDate.getMonth() === nowDate.getMonth() &&
                  issueDate.getDate() === nowDate.getDate()

                ) {
                  _document.receiptOptions.push({
                    title: 'Promijeni način plaćanja',
                    action: this.changePayment
                  })
                }

                break
              case 'STORNO':
                _document.receiptOptions = [
                  { title: 'Preuzmi račun', action: this.printReceiptNew }
                ]
                break
              case 'P':
                _document.receiptOptions = [
                  { title: 'Preuzmi ponudu', action: this.printReceiptNew },
                  {
                    title: 'Izradi račun iz ponude',
                    action: this.generateReceipt
                  }
                ]
            }
            if (_document.designation) {
              _document.receiptNumber = `${_document.designation.number}-${_document.designation.location_id}-${_document.designation.register_number}`
            }
            if (_document.issue_date_time) {
              _document.time = _document.issue_date_time.seconds
            }
            if (_document?.type?.flag !== 'BO' && _document?.type?.payer_name) {
              _document.customer = _document.type.payer_name
            } else {
              _document.customer = this.$t('$vuetify.receipts.retailCustomer')
            }
            ret = _document
          }
          return { ...ret, ...{ [`hover-${change.doc.data().id}`]: false } }
        })
      }

      this.receipts = this.receipts.filter((document, index, self) =>
        index === self.findIndex((t) => (
          t.id === document.id
        ))
      )
    },
    changeReceiptType (receipt) {
      this.$refs.chengeReceiptTypeDialog.open(receipt)
    },
    getReceiptsOrOffers () {
      this.lastDocSnapshot = null
      this.receipts = []
      this.unfiskReceipts = []
      this.loadReceipts()
    },
    stornoReceipt (receipt) {
      this.$refs.confirmStorno.open(
        '',
        `Storniraj račun ${receipt.receiptNumber}?`,
        { confirmText: 'Da', cancelText: 'Ne' }
      )
      this.selected = receipt
    },
    printReceiptNew (receipt) {
      this.loading = true
      var printTemplate = ''
      if (state.getCurrentCompany().print_template && state.getCurrentCompany().print_template !== '') {
        printTemplate = state.getCurrentCompany().print_template
      }

      let entity = 'racun'
      if (this.reciptOffer === 'offers') {
        entity = 'ponuda'
      }

      if (this.reciptOffer === 'virmans') {
        entity = 'virman'
      }

      var receipttemplate = functions.httpsCallable('receiptTemplate')

      var documentSubType = 'racun'
      if (state.getCurrentCompany().receipt_type && state.getCurrentCompany().receipt_type !== '') {
        documentSubType = state.getCurrentCompany().receipt_type
      }

      receipttemplate({
        template: printTemplate,
        companyId: receipt.company_details.id,
        documentId: receipt.id,
        documentType: entity,
        documentSubType: documentSubType,
        rawJson: ''
      })
        .then((result) => {
          this.loading = false
          if (result.data?.document !== '') {
            this.openPdfPrint(result.data?.document)
          }
        }
        )
    },
    onReceiptReprint (receipt) {
      const printerData = state.getSelectedPrinter()
      if (!printerData.width || printerData.width === '80') {
        reprint(printerData, receipt, 2)
      } else {
        print58(printerData, receipt, 2)
      }
    },
    prepareLogCall () {
      var req = new LogData()

      let userId = auth.currentUser.uid
      if (state.getCashRegisterUser().id && state.getCashRegisterUser().id !== '') {
        userId = state.getCashRegisterUser().id
      }

      req.action_name = 'Ispis kopije računa'
      req.action_id = '6'
      req.user_id = userId

      this.setLog(req)
    },
    reprintReceipt (receipt) {
      if (state.getCurrentCompany().save_log) {
        this.prepareLogCall()
      }
      const printerData = state.getSelectedPrinter()
      if (!printerData.width || printerData.width === '80') {
        reprint(printerData, receipt, 0)
      } else {
        print58(printerData, receipt, 0)
      }
    },
    reprintReceiptKonzumacijaJelaIpica (receipt) {
      const printerData = state.getSelectedPrinter()
      if (!printerData.width || printerData.width === '80') {
        reprint(printerData, receipt, 1)
      } else {
        print58(printerData, receipt, 1)
      }
    },
    cancelReceipt () {
      const that = this
      try {
        const receipt = Object.assign({}, this.selected)
        this.selected = {}
        const reqId = uuidv4()

        let receiptNumber = receipt.designation ? receipt.designation.number : 0
        df.doc(`cash_registers/${receipt.designation.register_id}`)
          .get()
          .then(reg => {
            if (reg && reg.exists) {
              if (reg.data()) {
                if (reg.data().status !== 'OK') {
                  this.$refs.confirmStorno.close()
                  that.showMsgBox({
                    text: that.$t('$vuetify.errors.unknownRegister'),
                    actions: ['cancel'],
                    cancelBtnText: that.$t('$vuetify.close'),
                    color: 'error'
                  })
                  return
                }
                if (this.reciptOffer === 'receipts') {
                  receiptNumber = reg.data().bill_sequence || 0
                } else if (this.reciptOffer === 'offers') {
                  receiptNumber = reg.data().offer_sequence || 0
                }
                const params = {
                  company_id: state.getCurrentCompany().id,
                  location_id: receipt.location_details.id,
                  receipt_id: receipt.id,
                  register_id: receipt.designation.register_id,
                  issue_date_time: parseInt(
                    (new Date().getTime() / 1000).toFixed(0)
                  ),
                  number: receiptNumber + 1,
                  reqid: reqId
                  // seller_id: auth.currentUser.uid,
                }

                that.loading = true
                that.$refs.confirmStorno.close()

                const receiptApi = functions.httpsCallable('receiptapi')
                receiptApi({
                  action: {
                    operation: 'set',
                    entity: 'storno',
                    params: params
                  }
                })
                  .then(function (response) {
                    that.loading = false
                    that.lastDocSnapshot = null
                    that.receipts = []
                    that.unfiskReceipts = []
                    that.loadReceipts()
                  })
                  .catch(function (err) {
                    that.loading = false
                    that.showMsgBox({
                      text: err && err.message ? err.message : 'An error has occurred',
                      actions: ['cancel'],
                      cancelBtnText: 'OK',
                      color: 'error'
                    })
                  })
              }
            } else {
              that.showMsgBox({
                text: that.$t('$vuetify.errors.unknownRegister'),
                actions: ['cancel'],
                cancelBtnText: that.$t('$vuetify.close'),
                color: 'error'
              })
              that.loading = false
              this.$refs.confirmStorno.close()
            }
          })
      } catch (err) {
        this.$refs.confirmStorno.close()
        that.loading = false
        that.showMsgBox({
          text: err || 'An error has occurred',
          actions: ['cancel'],
          cancelBtnText: 'OK',
          color: 'error'
        })
      }
    },
    generateReceipt (receipt) {
      if (receipt && receipt.type && receipt.type.flag && receipt.type.flag === 'V') {
        this.$refs.receiptFromVirman.open(receipt, this.multiplier)
      } else {
        this.$refs.receiptFromOffer.open(receipt, this.multiplier)
      }
    },
    payReceipt (receipt) {
      this.$refs.payReceipt.open(receipt)
    },
    onReceiptEdit (receipt) {
      this.receipts = this.receipts.map(r => {
        if (r.id === receipt.id) {
          r.payment.current_status = 'PROCESSING'
        }
        return r
      })
    },
    sendWarningToClient (receipt) {
      this.$refs.clientWarning.open(receipt, {
        action: 'WARNING_SENT',
        title: 'Opomeni korisnika',
        okBtn: 'Opomeni'
      })
    },
    statusToUnpaid (receipt) {
      this.$refs.statusToUnpaid.open(receipt)
    },
    changePayment (receipt) {
      this.$refs.paymentChanges.open(receipt)
    },
    onExpandFilters () {
      this.filtersExpanded = !this.filtersExpanded
      this.expandIcon = this.filtersExpanded ? 'mdi-minus' : 'mdi-plus'
    },

    parseReceiptNumber (receiptNumber) {
      receiptNumber = receiptNumber.replaceAll('/', '-')
      const parts = receiptNumber.split('-')
      if (parts.length !== 3) {
        return {
          number: 0,
          location_id: '',
          register_number: 0
        }
      }
      return { number: parseInt(parts[0]), location_id: parts[1], register_number: parseInt(parts[2]) }
    },

    async getAssociates () {
      var path = `/associates/${state.getCurrentCompany().id}/associate`
      var response = await callAssociates('get', path)

      if (response && response.status === 200 && response.data && response.data.associates) {
        this.defaultAssociates = Object.keys(response.data.associates)
          .map((key) => {
            return response.data.associates[key]
          })
          .filter((associate) => associate.status === 'OK' && associate.associate_type.BUYER)
        this.associates = clone(this.defaultAssociates)
      } else if (response.status === 404) {
        this.associates = []
        // Klijenti nisu pronađeni - tiho nastavi bez obavijesti
      } else {
        this.showMsgBox({
          text: 'Neuspjelo dohvaćanje klijenata',
          actions: ['cancel'],
          cancelBtnText: 'OK',
          color: 'error'
        })
      }
    },

    getMultiplier () {
      df.doc('project_constants/config').get()
        .then(doc => {
          if (doc.exists) {
            this.config = doc.data()
            this.multiplier = doc.data().item_amount.decimal_multiplier
          } else {
            console.warn('No such document!')
          }
        })
        .catch(error => {
          console.error('Error fetching document: ', error)
        })
    },

    issueBefore (issueDateTime) {
      const tmp = new Date(
        toISOLocal(
          new Date(issueDateTime * 1000)
        )
      )

      tmp.setDate(tmp.getDate() + 2)

      const before = parseInt(
        (tmp.getTime() / 1000).toFixed(0)
      )

      return before
    },
    resetField (field) {
      field === 'oib' ? this.oibFilterManual = '' : this.oibFilter = undefined
      this.applyFilter()
    },

    doSearch () {
      if (!/^(\s*|\d+)$/.test(this.searchNumber)) {
        this.searchNumber = ''
        return
      }
      this.lastDocSnapshot = null
      this.loadReceipts()
    },
    clearSearch () {
      // Explicitly clear search and reset to initial state
      this.searchNumber = ''
      this.lastDocSnapshot = null
      this.loadReceipts()
    }
  },
  async created () {
    const register = await df.doc(`cash_registers/${state.getCashRegister().id}`).get()
    this.register = register.data()
    this.last_balance_timestamp = register.data().last_balance_timestamp

    // Load initial receipts
    this.loadReceipts()
  },
  mounted () {
    this.setEnterAction(this.doSearch)
    this.setPosition(this.$refs.keyboard, '117px', '502px')
    // Associates are loaded on-demand in AccountDetailsDialogNew when user starts typing
    // this.getAssociates()
    this.getMultiplier()
    this.locations = [
      { name: this.$t('$vuetify.all'), id: '', location_id: '' }
    ]
    this.location = this.locations[0]

    this.reciptOffer = this.reciptOfferChoices[0].value

    const docRef = df.doc(
      `user_locations/${auth.currentUser.uid}.${state.getCurrentCompany().id}`
    )
    docRef.get()
      .then(doc => {
        if (
          doc.exists &&
          doc.data() &&
          doc.data().locations &&
          Object.keys(doc.data().locations).length > 0
        ) {
          this.locs = Object.keys(doc.data().locations).map(key => {
            return doc.data().locations[key]
          })
        }
      })
      .catch(error => {
        console.error('Error fetching document: ', error)
      })

    this.oibFilter = undefined
    this.oibFilterManual = ''
    this.receiptNumberFilter = ''
  }
}
</script>

<style scoped>
.v-dialog__content>>>.my-custom-dialog {
  position: absolute;
  top: 50px;
  border-radius: 25px;
}

.panel-container {
  margin-top: 1rem;
}

.text-wrap {
  width: min-content;
  margin: auto;
}

.panel-cell {
  padding: 0 1px 1px 0;
}

.active {
  background-color: var(--v-accent-darken3);
  color: white;
}

.label {
  font-size: 0.6rem;
  color: white;
}

tbody tr:nth-of-type(odd) {
  background-color: rgba(0, 0, 0, 0.15);
}

tr:hover {
  cursor: pointer;
}

/* Loading Overlay */
.loading-overlay-receipts {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(255, 255, 255, 0.3) !important;
  backdrop-filter: blur(8px) !important;
  -webkit-backdrop-filter: blur(8px) !important;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 10;
  border-radius: 0 !important;
}

.loading-spinner {
  color: #3989C9 !important;
  filter: drop-shadow(0 2px 4px rgba(0, 0, 0, 0.1));
}

/* Navigation Button in Header - Clean White Style */
.page-nav-btn-header {
  background: rgba(255, 255, 255, 0.95) !important;
  color: #3989C9 !important;
  border: 1px solid rgba(57, 137, 201, 0.25) !important;
  border-radius: 8px !important;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.08) !important;
  backdrop-filter: blur(10px) !important;
  transition: all 0.2s ease !important;
  text-transform: none !important;
  font-weight: 500 !important;
  font-size: 13px !important;
  letter-spacing: 0.3px !important;
  padding: 0 16px !important;
  height: 36px !important;
  min-width: 110px !important;
  margin: 0 4px !important;
}

.page-nav-btn-header:hover:not(:disabled) {
  background: rgba(255, 255, 255, 1) !important;
  border-color: #3989C9 !important;
  box-shadow: 0 2px 6px rgba(57, 137, 201, 0.2) !important;
  transform: translateY(-1px);
}

.page-nav-btn-header:disabled {
  opacity: 0.5 !important;
  cursor: not-allowed !important;
  background: rgba(245, 245, 245, 0.8) !important;
  border-color: rgba(200, 200, 200, 0.3) !important;
  color: rgba(158, 158, 158, 0.6) !important;
}

.page-nav-btn-header .v-icon {
  color: #3989C9 !important;
  font-size: 18px !important;
}

.page-nav-btn-header:disabled .v-icon {
  color: rgba(158, 158, 158, 0.6) !important;
}

/* Status Colors - Receipt Status Styles */
.status-ok-exp {
  background: linear-gradient(135deg,
    rgba(76, 175, 80, 0.08) 0%,
    rgba(56, 142, 60, 0.06) 100%) !important;
  border-left: 4px solid rgba(76, 175, 80, 0.6) !important;
  backdrop-filter: blur(10px) !important;
}

.status-ok-exp:hover {
  background: linear-gradient(135deg,
    rgba(76, 175, 80, 0.12) 0%,
    rgba(56, 142, 60, 0.1) 100%) !important;
  border-left-color: rgba(76, 175, 80, 0.8) !important;
}

.status-warn-exp {
  background: linear-gradient(135deg,
    rgba(255, 152, 0, 0.08) 0%,
    rgba(255, 193, 7, 0.06) 100%) !important;
  border-left: 4px solid rgba(255, 152, 0, 0.6) !important;
  backdrop-filter: blur(10px) !important;
}

.status-warn-exp:hover {
  background: linear-gradient(135deg,
    rgba(255, 152, 0, 0.12) 0%,
    rgba(255, 193, 7, 0.1) 100%) !important;
  border-left-color: rgba(255, 152, 0, 0.8) !important;
}

.status-warn-after-exp {
  background: linear-gradient(135deg,
    rgba(255, 152, 0, 0.12) 0%,
    rgba(245, 124, 0, 0.1) 100%) !important;
  border-left: 4px solid rgba(255, 152, 0, 0.8) !important;
  backdrop-filter: blur(10px) !important;
}

.status-warn-after-exp:hover {
  background: linear-gradient(135deg,
    rgba(255, 152, 0, 0.16) 0%,
    rgba(245, 124, 0, 0.14) 100%) !important;
  border-left-color: rgba(255, 152, 0, 1) !important;
}

.status-failed-exp {
  background: linear-gradient(135deg,
    rgba(244, 67, 54, 0.08) 0%,
    rgba(211, 47, 47, 0.06) 100%) !important;
  border-left: 4px solid rgba(244, 67, 54, 0.6) !important;
  backdrop-filter: blur(10px) !important;
}

.status-failed-exp:hover {
  background: linear-gradient(135deg,
    rgba(244, 67, 54, 0.12) 0%,
    rgba(211, 47, 47, 0.1) 100%) !important;
  border-left-color: rgba(244, 67, 54, 0.8) !important;
}

.status-failed-expired {
  background: linear-gradient(135deg,
    rgba(244, 67, 54, 0.12) 0%,
    rgba(183, 28, 28, 0.1) 100%) !important;
  border-left: 4px solid rgba(244, 67, 54, 0.8) !important;
  backdrop-filter: blur(10px) !important;
}

.status-failed-expired:hover {
  background: linear-gradient(135deg,
    rgba(244, 67, 54, 0.16) 0%,
    rgba(183, 28, 28, 0.14) 100%) !important;
  border-left-color: rgba(244, 67, 54, 1) !important;
}

.status-storno {
  background: linear-gradient(135deg,
    rgba(120, 120, 130, 0.08) 0%,
    rgba(90, 90, 100, 0.06) 100%) !important;
  border-left: 4px solid rgba(120, 120, 130, 0.6) !important;
  backdrop-filter: blur(10px) !important;
}

.status-storno:hover {
  background: linear-gradient(135deg,
    rgba(120, 120, 130, 0.12) 0%,
    rgba(90, 90, 100, 0.1) 100%) !important;
  border-left-color: rgba(120, 120, 130, 0.8) !important;
}

.status-reversed {
  background: linear-gradient(135deg,
    rgba(97, 84, 164, 0.08) 0%,
    rgba(77, 64, 144, 0.06) 100%) !important;
  border-left: 4px solid rgba(97, 84, 164, 0.6) !important;
  backdrop-filter: blur(10px) !important;
}

.status-reversed:hover {
  background: linear-gradient(135deg,
    rgba(97, 84, 164, 0.12) 0%,
    rgba(77, 64, 144, 0.1) 100%) !important;
  border-left-color: rgba(97, 84, 164, 0.8) !important;
}
</style>

<style>
::v-deep input::-webkit-outer-spin-button,
::v-deep input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}
</style>
